import Vue from 'vue'
import CC from "./CC.vue"
import ADMIN from "./ADMIN.vue"
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import { defaults } from './assets/config'
//import messages from defaults.i18n
//import messages from "./i18n/i18n-ssk.json"
import ModDefaults from "./modules/ModDefaults"
import ModRoles from "./modules/ModRoles"
import router from "./routes/Router"
import ModAppmode from "./modules/ModAppmode"
import ModPurchase from "./modules/ModPurchase"
//import ModAccount from "./modules/ModAccount"
import { Account } from 'psy-sdk'
import ModGoods from "./modules/ModGoods"
import VueCookie from "vue-cookie"
import Vuetify from 'vuetify'
//import './modules/registerServiceWorker'
import { init } from "psy-sdk"
init({
  hostname: defaults.mode === "production" ? "service.psyfiers.ch"
    : defaults.mode === "wsf" ? "develop.psyfiers.ch"
      : defaults.mode === "cc1" ? "cc1.psyfiers.ch"
        : defaults.mode === "cc2" ? "cc2.psyfiers.ch"
          : defaults.mode === "cc3" ? "cc3.psyfiers.ch"
            : defaults.mode === "ssk" ? "prod.swiss-skills.ch" : "staging.psyfiers.ch",
  showErrors: false,
  debug: false
})

import 'vuetify/dist/vuetify.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import 'typeface-roboto/index.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

if (defaults.mode === "ssk") {
  import("./scss/ssk.scss")
} else if (defaults.mode === "staging") {
  import("./scss/staging.scss")
} else if (defaults.mode === "wsf") {
  import("./scss/wsf.scss")
} else if (defaults.mode === "cc1") {
  import("./scss/cc1.scss")
} else if (defaults.mode === "cc2") {
  import("./scss/wsf.scss")
} else if (defaults.mode === "cc3") {
  import("./scss/wsf.scss")
} else {
  import("./scss/default.scss")
}


const messages = require("./i18n/" + defaults.i18n)

Vue.config.productionTip = false
Vue.config.devtools = true;

Vue.use(VueI18n)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueCookie)
Vue.use(Vuetify)

const i18n = new VueI18n({
  locale: defaults.language,
  messages
})

Vue.prototype.$selectedAccount = {}
Vue.prototype.$loginData = {
  hasRole(roleId) {
    return ModRoles.hasRole(roleId, this.data)
  }
}
Vue.prototype.$appmode = {
  mode: window.location.href.includes("cc-admin") ? "admin" : "cc",
  view: [],
  _moderatorConf: [],
  _deliveryConf: defaults.hideDeliveryAddress ? [{ deliveryAddress: false }] : [],
  moderatorNeeded() {
    return this._moderatorConf.length ? this._moderatorConf.findIndex(e => e.moderator) > -1 : true
  },
  deliveryAddressNeeded() {
    return this._deliveryConf.length ? this._deliveryConf.findIndex(e => e.deliveryAddress) > -1 : true
  }
}
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$events = Vue.observable({
  sidebar: {
    show: false
  },
  data: []
})

ModAppmode.loadConfig(window.location.href).then(config => {
  Vue.prototype.$appmode.view = config.goods
  if (config.goods) {
    ModGoods.moderatorNeeded(config.goods).then(result => {
      Vue.prototype.$appmode._moderatorConf = result
    })
    ModGoods.deliveryAddressNeeded(config.goods).then(result => {
      Vue.prototype.$appmode._deliveryConf = result
    })
  }
})

ModDefaults.init().then(defaults => {
  Vue.prototype.$CCdefaults = defaults
  ModDefaults.defaults = defaults
})

ModRoles.init().then(roles => {
  ModRoles.roles = roles
})

router.beforeEach((to, from, next) => {
  if (to.path !== "/" && !Vue.prototype.$loginData.data) {
    next("/")
  } else {
    next()
  }
})

new Vue({
  i18n,
  router,
  vuetify: new Vuetify(),
  //render: h => h(App),
  mounted() {
    let getQueryParam = (name, url = window.location.href) => {
      name = name.replace(/[[\]]/g, "\\$&")
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)

      if (!results) return null
      if (!results[2]) return null
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }
    let mode = getQueryParam("mode"),
      ref = getQueryParam("ref"),
      err = getQueryParam("e"),
      lang = getQueryParam("lang")


    if (lang) {
      if (lang == "de") {
        this.$i18n.locale = "de"
      }
      if (lang == "fr") {
        this.$i18n.locale = "fr"
      }
      if (lang == "it") {
        this.$i18n.locale = "it"
      }
      if (lang == "en") {
        this.$i18n.locale = "en"
      }
      this.$eventBus.$emit("language-changed")
    } else {
      let l = this.$cookie.get("lang")
      if (l) {
        this.$i18n.locale = l
        this.$eventBus.$emit("language-changed")
      }
    }

    this.$events.data.push({
      id: 1,
      date: new Date(),
      message: "This is a system generated message",
      active: true
    })

    if (mode && mode === "register") {
      this.$router.replace({ path: "/", query: { mode: "register" } })
    } else if (ref) {
      ModPurchase.loadRef(ref).then(async data => {
        try {
          let account = new Account(data[0].id)
          await account.read()
          this.$selectedAccount.data = account.toJson()
          this.$loginData.data = data
          this.$appmode.mode === "cc"
          this.$eventBus.$emit("login")
          if (err && err === "1") {
            this.$router.replace({ path: "/dashboard" })
          } else {
            this.$router.replace({ path: "/bought-products" })
          }
        } catch (err) {
          console.error(err)
          this.$router.replace("/")

        }
        /*
        ModAccount.read(data.accounts[0].id).then((account) => {
          this.$selectedAccount.data = account
          this.$loginData.data = data
          this.$appmode.mode === "cc"
          this.$eventBus.$emit("login")
          if (err && err === "1") {
            this.$router.replace({ path: "/dashboard" })
          } else {
            this.$router.replace({ path: "/bought-products" })
          }
        }).catch(err => {
          console.error(err)
          this.$router.replace("/")
        })
        */
      }).catch(err => {
        console.error(err)
        this.$router.replace("/")
      })
    } else {
      this.$router.replace("/")
    }
  },
  render: h => h(Vue.prototype.$appmode.mode === "admin" ? ADMIN : CC),
  el: "#app",
})
